'use client';

import { ButtonLink } from '~/components/primitives';
import type { ErrorProps } from '~/modules/next';
import Title from '../../../../../components/utils/Title';

export default function __Error(props: ErrorProps) {
    console.error(props.error);
    return (
        <div className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center">
                <p className="text-base font-semibold text-orange-600">500</p>
                <Title as="h1" size="4xl" weight="xbold">
                    Something went wrong for this activity
                </Title>
                <p className="mt-6 text-base leading-7 text-blue-600">
                    Sorry, we couldn’t find the page you’re looking for.
                </p>
                <div className="mt-10">
                    <ButtonLink href="/" variant="tertiary">
                        Go back to homepage
                    </ButtonLink>
                </div>
            </div>
        </div>
    );
}
